
      console.log('thy test',`${import.meta.env}`)
      console.log('thy test VITE_APP_LOG_PLUGIN', `${import.meta.env.VITE_APP_LOG_PLUGIN}`)
      !(function (c, b, a) { c[a] || (c[a] = {}); c[a].config = {}; var dom = document.createElement("script");dom.setAttribute("crossorigin", "anonymous"); dom.setAttribute("src", import.meta.env.VITE_APP_LOG_PLUGIN); document.body.insertBefore(dom, document.body.firstChild); })(window, document, "__ta");
    